import { useNavigate } from "react-router-dom";
import { serviceCard } from "../../constants/data";
import useTranslate from "../../hooks/useTranslate";
import "./Service.scss";
import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Navbar/MainNavbar/Navbar";
import Image1 from "../../img/kavak-members/0002.jpg";
const Services = () => {
  const { translate, language } = useTranslate();
  const navigate = useNavigate();
  const isRTL = language === "fa";

  return (
    <div className={`service-page ${isRTL ? "rtl-mode" : "ltr-mode"}`}>
      <Navbar />

      {/* ===== Service Cards Grid ===== */}
      <div className="service-page__container">
        <div className="service-page__grid">
          {serviceCard.map((service, index) => {
            return (
              <div
                key={index}
                className="service-card"
                onClick={() => navigate(service.href)}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* ===== بخش عکس (بالا) ===== */}
                <div className="service-card__image-wrapper">
                  <img
                    src={service.src}
                    alt={translate(service.titleKey) || service.title}
                    className="service-card__image"
                  />
                  <div className="service-card__image-overlay" />
                </div>

                {/* ===== خط طلایی بین عکس و محتوا ===== */}
                <div className="service-card__gold-line" />

                {/* ===== بخش محتوا (پایین) ===== */}
                <div className="service-card__content">
                  <div className="service-card__header">
                    <div className="service-card__icon-wrapper">
                      {service.icon}
                    </div>
                    <h3 className="service-card__title">
                      {translate(service.titleKey) || service.title}
                    </h3>
                  </div>

                  {/* توضیحات */}
                  <p className="service-card__description">
                    {translate(service.descriptionKey, { defaultValue: translate(service.description) })}
                  </p>

                  {/* Arrow */}
                  <div className="service-card__arrow">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="https://www.w3.org/2000/svg"
                    >
                      <path
                        d={
                          isRTL
                            ? "M19 12H5M5 12L11 18M5 12L11 6"
                            : "M5 12H19M19 12L13 18M19 12L13 6"
                        }
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Services;
